export default "__VITE_ASSET__55357a34__"